import React, { Component } from 'react';

import { ListLayout } from '../containers/Layout';
import { isEmpty } from "lodash";
import { TableRow, TableCell, Button, TableHead, TableBody, IconButton } from '@material-ui/core';
import { AddRounded, DeleteRounded } from '@material-ui/icons';
import Currency from '../../../../commonModules/Currency';
// const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })

class ListReapproExt extends Component{
    state = { }

    createReapproList(){
        const { REAPPRO_EXT, SHOPS } = this.props
        return  Object.values(REAPPRO_EXT).map( reappro => { 
            const shopDest = SHOPS[reappro.shop_dest]
            const shop = SHOPS[reappro.shop_id]
            const total = reappro.total_price + (reappro.taxes || 0) + (reappro.transport || 0)
            // const margin = reappro.price_margin ? reappro.total_price * (reappro.price_margin / 100 ) : 0

            return (        
                <TableRow key={reappro.id}>
                    {/* <TableCell>{reappro.id}</TableCell> */}
                    <TableCell>{(new Date(reappro.date)).toLocaleString('fr-FR')}</TableCell>
                    <TableCell>
                        <a href="#" onClick={ ()=> this.props.handleSingleShop(shop) }> {shop.name}</a>
                    </TableCell>
                    {/* <TableCell>
                        <a href="#" onClick={ ()=>this.props.handleSingleShop(shopDest) }> {shopDest && shopDest.name}</a>
                    </TableCell> */}
                    
                    <TableCell>{reappro.comments}</TableCell>
                    <TableCell><Currency value={total} /></TableCell>
                    {/* <TableCell>{reappro.price_margin || 0}%</TableCell>
                    <TableCell>{formatNumbers.format(margin)}</TableCell> */}
                    <TableCell>
                        <IconButton color="secondary" onClick={() => this.props.handleSingleReaExtern(reappro, shop, shopDest)}>
                            <AddRounded />
                        </IconButton>
                    </TableCell>
                    <TableCell>
                        <IconButton  
                            onClick={()=> this.props.handleDelete(reappro)  }
                        >
                            <DeleteRounded  color="error" />
                        </IconButton>
                    </TableCell>
                </TableRow>
            )

            
        })
    }

    render(){
    
        return(
            <ListLayout>
                <TableHead>
                    <TableRow>
                        {/* <TableCell>ID</TableCell> */}
                        <TableCell>Date</TableCell>
                        <TableCell>Shop</TableCell>
                        {/* <TableCell>Destination</TableCell> */}
                        {/* <TableCell>Statut</TableCell> */}
                        
                        <TableCell>Remarques</TableCell> 
                        <TableCell>Total</TableCell> 
                        {/* <TableCell colSpan={2}>Marge</TableCell>  */}
                        <TableCell>Détails</TableCell>
                        <TableCell>Options</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { !isEmpty(this.props.REAPPRO_EXT) && 
                        this.createReapproList()
                    }
                    { isEmpty(this.props.REAPPRO_EXT) && 
                    <TableRow>
                        <TableCell colSpan="7">
                            <div className="text-center">
                                <h5>Pas de Reapprovisionnement externe</h5> 
                                Cliquez sur <b className="onglet">"Nouveau"</b> Pour en créer un
                            </div>
                        </TableCell>
                    </TableRow>
                    }
                </TableBody>
            </ListLayout>                                             
        )
    }
}



export default ListReapproExt